module.exports = __webpack_public_path__ + "static/media/rosa.d3a3ef42.png";